import logger from './utils/logger';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './App.css';
import App from './App'; // Import App

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HashRouter>
      <App /> {/* Render App */}
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(logger.log);
